import React from "react";

const BackOrderFilters = ({
    filter,
    updateFilterParam,
    classname,
    isPunchOutAccess=false
}) => (
    <div className={classname}>
        <p>Filter results by current account selections (at top of screen)</p>
        <div className="rightCol clearfix">
            <label htmlFor="shipToAddress" className="normal">
                <input id="shipToAddress" name="shipToAddress" type="checkbox" checked={filter.shipToAddress} onChange={updateFilterParam} />
                    Ship to Address
            </label>
            <label htmlFor="salesAgreement" className="normal">
                <input id="salesAgreement" name="salesAgreement" type="checkbox" checked={isPunchOutAccess ? isPunchOutAccess : filter.salesAgreement} onChange={updateFilterParam} readOnly={isPunchOutAccess ? isPunchOutAccess : false} />
                    Sales Agreement
            </label>
        </div>
        <br />
    </div>
);

export default BackOrderFilters;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/backOrderFilterComponent.js